// Author Liang Gangqiang
// Date 2021-07-19 14:17:48

class SithMesNcrTaskNcc {
constructor({
        id = null,
        ncrProcessId = '',
        nccItemId = '',
        value = '',
        remark = ''}
= {}) {
    this.id = id;
    this.ncrProcessId = ncrProcessId;
    this.nccItemId = nccItemId;
    this.value = value;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesNcrTaskNcc();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.quality.sithMesNcrTaskNcc.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.sith.quality.sithMesNcrTaskNcc.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nccItemName',
        label: 'label.sith.quality.sithMesNcrTaskNcc.grid.nccItemName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'value',
        label: 'label.sith.quality.sithMesNcrTaskNcc.grid.value',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.quality.sithMesNcrTaskNcc.grid.createdByName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.quality.sithMesNcrTaskNcc.grid.createdTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesNcrTaskNcc.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    ncrProcessIdFilter : "",
    nccItemIdFilter : "",
    valueFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'ncrProcessIdFilter',
        label: 'label.sith.quality.sithMesNcrTaskNcc.filter.ncrProcessId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesNcrProcessTask'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'nccItemIdFilter',
        label: 'label.sith.quality.sithMesNcrTaskNcc.filter.nccItemId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'sithMesNcrTaskNccItem'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'valueFilter',
        label: 'label.sith.quality.sithMesNcrTaskNcc.filter.value',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'ncrProcessId',
        label: 'label.sith.quality.sithMesNcrTaskNcc.entity.ncrProcessId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'sithMesNcrProcessTask'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'nccItemId',
        label: 'label.sith.quality.sithMesNcrTaskNcc.entity.nccItemId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,required: true
            ,entity: 'sithMesNcrTaskNccItem'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'value',
        label: 'label.sith.quality.sithMesNcrTaskNcc.entity.value',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesNcrTaskNcc.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesNcrTaskNcc, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
